import { createRefPath_event } from 'global/firestoreData/appData/appRefPaths';
import { useCallback, useContext } from 'react';
import { ParentContext } from '../ParentContext';

const _collectionName = '_videoConferences'

export const useVideoConference = () => {

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { paps_state } = states
  const { pathViews } = paps_state ?? {}
  const { database_fns } = fns

  const getVideoConferences = useCallback(async (callback) => {
    if (pathViews.events) {
      const meetingRooms = {}
      const _refPath = createRefPath_event(pathViews, [_collectionName])
      database_fns.get_data({ refPath: _refPath }).then(vcs => {
        const mrs = { ...meetingRooms }
        if (vcs) {
          Object.keys(vcs).forEach(key => {
            mrs[key] = vcs[key]
          })
        }
        callback(vcs, mrs)
      })
    }
  }, []);

  return { getVideoConferences }
}
